import { Component, Inject, Input, OnDestroy } from "@angular/core";

import { OnInit } from "@angular/core";
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { FieldGeneratorService } from "../../services/field-generator.service";

import { MedicineDetailComponent } from "../medicine-detail/medicine-detail.component";

import { BatchService } from "../../services/batch.services";
import { AddBatchDialogComponent } from "../add-batch/add-batch-dialog.component";
import { IncidentsDialogComponent } from "../incidents-dialog/incidents-dialog.component";
import { FormDialogComponent } from '../form-dialog/form-dialog.component';
import { MessageService } from '../../services/message.service';
import { EventBusService } from '../../services/event-bus.service';
import { GlobalCfgService } from '../../services/globalcfg.service';
import { Router, ActivatedRoute } from '@angular/router';
import { DistributionDialogComponent } from './distribution-dialog/distribution-dialog.component';
import { ConfirmationDialogComponent } from '../confirm-dialog/confirm-dialog.component';
import { FormControl } from "@angular/forms";
import { EditBatchDialogComponent } from "../edit-batch/edit-batch-dialog.component";
import { ViewBulkBatchComponet } from "./view-bulk-batch/view-bulk-batch-dialog.component";
import { SubscriptionService } from "../../services/subscription.service";
@Component({
  selector: "rm-manage-batch",
  templateUrl: "./manage-batch.component.html",
  styleUrls: ["./manage-batch.component.css"]
})
export class ManageBatchComponent implements OnInit, OnDestroy {
  @Input()
  hideToolbar: boolean = false;
  formGroup: any;
  data: any;
  @Input()
  productId: string;

  @Input()
  gcp: string;

  @Input()
  batchNum: string;

  //Used for pagination
  bookmarks: any[] = [];
  totalCount: number = 0;
  pageSize: number = 5;
  skip: number = 0;
  moveToFirstPage: boolean = false;
  page: any;

  searchTxt: string = '';
  selectedProduct: string = 'all';
  selectedLocation: string = 'all';
  searchByBatch: boolean = false;
  isReadOnly: boolean = false;
  batchData: any[] = [];
  columns: any[];
  products: any;
  locations: any;
  subscriptions: any[] = [];
  labels: any;
  role: any;
  currentOrgObj: any;

  constructor(
    private dialog: MatDialog,
    private fgService: FieldGeneratorService,
    private batchService: BatchService,
    private ebService: EventBusService,
    private msgService: MessageService,
    private globalCfgService: GlobalCfgService,
    private route: ActivatedRoute,
    private subscriptionService: SubscriptionService
  ) { }

  ngOnInit() {
    this.subscriptions.push(this.ebService.productsListValue$.subscribe(
      (list) => this.products = list
    ));
    this.subscriptions.push(this.ebService.locationsListValue$.subscribe(
      (list) => this.locations = list
    ));

    this.subscriptions.push(this.ebService.particpantSelectionFetchedValue$.subscribe(
      (gcp) => {
        this.gcp = gcp;
        this.load();
      }
    ));

    if (this.route.parent) {
      this.route.parent.url.subscribe(url => {
        //always the first part is role
        this.role = url.values().next().value.path;
      });
    }

    this.load();
  }

  load() {
    this.loadBatches();
    this.ebService.loadProductsList(this.gcp);
    this.ebService.loadLocationsList(this.gcp);
  }

  ngOnDestroy() {
    this.subscriptions.forEach(s => s.unsubscribe());
  }

  // loadBatches(page?) {
  //   this.labels = this.globalCfgService.getSettingValue('labels');
  //   this.columns = [
  //     { name: 'batchNo', displayName: "Batch No.", actionable: true, },
  //     { name: "batchDt", displayName: "Batch Date", type: 'date', format: "DD/MM/YYYY" },
  //     { name: "expiryDt", displayName: "Expiry Date", type: 'date', format: "DD/MM/YYYY" },
  //     { name: "qty", displayName: "Batch Quantity", type: 'unknown' },
  //     { name: "img", displayName: "", type: "image", editable: "false" },
  //     { name: "name", displayName: this.labels['medicine'], actionable: true },
  //     { name: "location", displayName: this.labels['mfg_location'] },
  //     { name: "actions", type: "actions", displayName: "" }
  //   ];

  //   if (!this.gcp) {
  //     this.gcp = this.globalCfgService.getGcp();
  //   }
  //   var obj = {};

  //   if (this.gcp) {
  //     obj['gcp'] = this.gcp;
  //   }

  //   if (this.productId) {
  //     obj['gtin'] = this.productId;
  //     this.selectedProduct = this.productId;
  //   }

  //   if (this.batchNum) {
  //     obj["batch"] = this.batchNum;
  //     this.searchTxt = this.batchNum;
  //     this.searchByBatch = true;
  //   }

  //   if (this.selectedLocation != 'all') {
  //     obj['gln'] = this.selectedLocation
  //   }

  //   if (this.selectedProduct != 'all') {
  //     obj['gtin'] = this.selectedProduct
  //   }

  //   if (this.searchByBatch) {
  //     obj['batch'] = this.searchTxt;
  //   }

  //   obj['pageSize'] = (page && page.pageSize) || this.pageSize;
  //   //limit
  //   if (page && page.pageIndex) {
  //     obj['bookmark'] = this.bookmarks[page.pageIndex];
  //     //skip
  //   }

  //   this.batchService.get(obj).subscribe((response: any[]) => {
  //     if (page && page.pageIndex) {
  //       this.bookmarks[page.pageIndex + 1] = response['metadata'].bookmark;
  //     } else {
  //       this.bookmarks[1] = response['metadata'].bookmark;
  //     }
  //     this.totalCount = response['metadata'].totalCount;

  //     response['result'].forEach(item => {
  //       var actions = [
  //         { name: "edit", tip: "Edit Batch" },

  //         { name: "map", tip: "View Distribution" },
  //         // { name: "cloud_download", tip: "Download Label" }
  //       ]
  //       if (!item["isRecalled"] && !item["isCancelled"] && this.role == 'brand-owner') {
  //         actions.push(
  //           { name: "input", tip: "Initate Recall for the batch" }
  //         );

  //         if (!item["isCompleted"]) {
  //           actions.push(
  //             { name: "check_circle", tip: "Mark Batch as completed" },
  //             { name: "cancel", tip: "Cancel Batch" }
  //           );
  //         }
  //       }
  //       item["actions"] = actions;
  //     });

  //     this.batchData = Object(response['result']);
  //   });
  // }

  loadBatches(page?) {
    this.labels = this.globalCfgService.getSettingValue('labels');
    this.columns = [
      { name: 'batchNo', displayName: "Batch No.", actionable: true, },
      { name: "batchDt", displayName: "Batch Date", type: 'date', format: "DD/MM/YYYY" },
      { name: "expiryDt", displayName: "Expiry Date", type: 'date', format: "DD/MM/YYYY" },
      { name: "qty", displayName: "Batch Quantity", type: 'unknown' },
      { name: "img", displayName: "", type: "image", editable: "false" },
      { name: "name", displayName: this.labels['medicine'], actionable: true },
      { name: "location", displayName: this.labels['mfg_location'] },
      { name: "actions", type: "actions", displayName: "" }
    ];

    if (!this.gcp) {
      this.gcp = this.globalCfgService.getGcp();
      // get current org data to check if isAlsoInner option is to be displayed
      const filter = { "where": { "gcp": this.gcp } };
      this.subscriptionService.getCurrentOrgData(filter).subscribe(
        (response: any) => {
          if (response.count === 1) {
            this.currentOrgObj = response.data[0];
          }
        }
      );
    }
    var obj = {};

    if (this.gcp) {
      obj['gcp'] = this.gcp;
    }

    if (this.productId) {
      obj['gtin'] = this.productId;
      this.selectedProduct = this.productId;
    }

    if (this.batchNum) {
      obj["batch"] = this.batchNum;
      this.searchTxt = this.batchNum;
      this.searchByBatch = true;
    }

    if (this.selectedLocation != 'all') {
      obj['gln'] = this.selectedLocation
    }

    if (this.selectedProduct != 'all') {
      obj['gtin'] = this.selectedProduct
    }

    if (this.searchByBatch) {
      obj['batch'] = this.searchTxt;
    }

    obj['pageSize'] = (page && page.pageSize) || this.pageSize;
    if (page) {
      this.skip = page.pageIndex * this.pageSize;
      obj['skip'] = this.skip;
    } else if (page === undefined) {
      obj['skip'] = this.skip;
    }

    this.batchService.get(obj).subscribe((response: any[]) => {
      if (page && page.pageIndex) {
        this.bookmarks[page.pageIndex + 1] = response['metadata'].bookmark;
      } else {
        this.bookmarks[1] = response['metadata'].bookmark;
      }
      this.totalCount = response['metadata'].totalCount;

      response['result'].forEach(item => {
        var actions = [];
        if (this.role == 'brand-owner') {
          actions.push({ name: "edit", tip: "Edit Batch" });
        }
        actions.push(
          { name: "map", tip: "View Distribution" },
          // { name: "cloud_download", tip: "Download Label" }
        );
        if (!item["isRecalled"] && !item["isCancelled"] && this.role == 'brand-owner') {
          actions.push(
            { name: "input", tip: "Initate Recall for the batch" }
          );

          if (!item["isCompleted"]) {
            actions.push(
              { name: "check_circle", tip: "Mark Batch as completed" },
              { name: "cancel", tip: "Cancel Batch" }
            );
          }
        }
        item["actions"] = actions;
      });

      this.batchData = Object(response['result']);
    });
  }


  add() {
    const dialogRef = this.dialog.open(AddBatchDialogComponent, {
      width: "1024px"
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result && result.status) {
        this.loadBatches(this.page);
      }
    });
  }

  setSearchByBatch(status) {
    if (!status && this.searchTxt.length > 0) {
      return;
    }
    this.searchByBatch = status;
  }

  clear() {
    this.searchTxt = '';
    this.searchByBatch = false;
    this.applyFilter();
  }

  onActionableClicked(e) {
    var rec = e.record;
    switch (e.actionName) {
      case "name":
        this.dialog.open(MedicineDetailComponent, {
          width: "2400px",
          data: { medicineId: rec.gtin }
        });
        break;
      case "batchNo":
        //common method used to display view bulk batch dilog and add batch dialog
        this.toggleBulkApiDialog(rec);
        break;
    }
  }
  onActionClicked(e) {
    var rec = e.record;
    switch (e.actionName.name) {
      case "edit":
        //toggle bulk api and edit batch dialogs...
        this.toggleEditBulkApiDialog(rec);
        break;
      case "input":
        var fields = this.fgService.getFields(
          [
            { name: "description", displayName: "Topic", type: "longstring" }
          ],
          { description: "" }
        );
        const dialogRef = this.dialog.open(FormDialogComponent, {
          width: "450px",
          data: {
            title: "Recall Batch",
            fields: fields,
            note: 'You are about to initiate a batch recall. Enter reason and proceed.',
            saveBtnTxt: 'Initate Recall'
          },
        });

        dialogRef.afterClosed().subscribe(result => {
          this.batchService
            .recall({
              batch: rec.batchNo,
              gcp: this.globalCfgService.getGcp(),
              description: result.description
            })
            .subscribe(
              (response: any[]) => {
                this.msgService.showSuccess(this.msgService.batchRecall);
                this.loadBatches();
              },
              error => {
                console.log("Service error:");
              }
            );
        });
        break;
      case "map":
        this.dialog.open(DistributionDialogComponent, {
          width: "2400px",
          data: { batchNum: rec.batchNo, gcp: this.globalCfgService.getGcp() }
        });
        break;
      case "cancel":
        const dialogRef2 = this.dialog.open(ConfirmationDialogComponent, {
          width: '450px',
          data: {
            note: 'You can promptly cancel the batch if you could not use it due to an operational error.',
            message: 'Are you sure you want to cancel the batch?'
          }
        });
        dialogRef2.afterClosed().subscribe(result => {
          if (result == 'yes') {
            this.batchService.cancel({ batchNo: rec.batchNo }).subscribe(
              (response: any[]) => {
                this.msgService.showSuccess(this.msgService.batchDelete);
                this.loadBatches();
              },
              error => {
                console.log("Service error:");
              }
            );
          }
        });
        break;
      case "check_circle":
        const dialogRef3 = this.dialog.open(ConfirmationDialogComponent, {
          width: '450px',
          data: {
            note: 'You cannot generate labels anymore after a batch is marked as completed',
            message: 'Are you sure you want to mark the batch as completed?'
          }
        });
        dialogRef3.afterClosed().subscribe(result => {
          if (result == 'yes') {
            this.batchService.complete({ batchNo: rec.batchNo }).subscribe(
              (response: any[]) => {
                this.msgService.showSuccess(this.msgService.batchComplete);
                this.loadBatches();
              },
              error => {
                console.log("Service error:");
              }
            );
          }
        });
        break;
      default:
        console.log("Unhandled action: ", e.actionName);
      case "check_circle":
    }

  }

  styleRow(rec) {
    if (rec.isRecalled) {
      return "recalled-row";
    }
    if (rec.isCancelled) {
      return "invalid-row";
    }
  }

  showRecalledBatchTip(rec) {
    if (rec.isRecalled) {
      return 'Batch has been recalled. Reason - ' + rec.recalledDescription;
    }
    if (rec.isCancelled) {
      return 'Batch has been cancelled';
    }
  }

  applyFilter() {
    this.moveToFirstPage = true;
    this.skip = 0;
    // this.paginator.pageIndex = 0;
    this.loadBatches();
  }

  onPageChanged(page) {
    this.pageSize = page.pageSize;
    this.page = page;
    this.loadBatches(page);
  }

  toggleBulkApiDialog(rec) {
    console.log(this.currentOrgObj.isbulkAPIType);
    this.currentOrgObj.isbulkAPIType
      ?
      this.dialog.open(ViewBulkBatchComponet, {
        width: "750px",
        data: {
          rec: rec,
          title: 'Bulk API Batch Details',
          currentOrgObj: this.currentOrgObj,
          toogleActionBtns: false
        }
      })
      :
      this.dialog.open(AddBatchDialogComponent, {
        width: "2400px",
        data: {
          rec: rec,
          title: 'Batch Detail'
        }
      })
  }

  toggleEditBulkApiDialog(rec) {
    this.currentOrgObj.isbulkAPIType
      ?
      this.viewBulkBatchDialog(rec)
      :
      this.dialog.open(EditBatchDialogComponent, {
        width: "2400px",
        data: {
          rec: rec,
          title: 'Edit Batch Detail'
        }
      })
  }

  //update the bulk bacth api 
  viewBulkBatchDialog(rec) {
    const dialogRef4 = this.dialog.open(ViewBulkBatchComponet, {
      width: "750px",
      data: {
        rec: rec,
        title: 'Edit Bulk API Batch Details',
        currentOrgObj: this.currentOrgObj,
        toogleActionBtns: true
      }
    })
    dialogRef4.afterClosed().subscribe(result => {
      if (result) {
        this.loadBatches();
      }
    });
  }
}
